// Tanner Fry
// dev.lasutriv@gmail.com
// Component used for creating a trask for the task tracker.

import '../../css/components/Animations.css';

import { ErrorMessage, Field, Form, Formik } from 'formik';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { APIGetUserLoginResponse, ReturnPropsAPIGetUserLoginResponse } from '../../../api/APIUsers';
import { useAppDispatch } from '../../../AppHooks';
import { SubscriptionPlan } from '../data/SubscriptionData';
import Loading from '../elements/Loading';
import { CustomPasswordField } from '../inputs/CommonInputs';

interface ILoginFormProps {
    userPlan: SubscriptionPlan;
    apiLoginData: ReturnPropsAPIGetUserLoginResponse;
    setApiLoginData: (apiLoginData: ReturnPropsAPIGetUserLoginResponse) => void;
}

function LoginForm(props: ILoginFormProps) {  
    const navigate = useNavigate();
    const [passedPasswordVerification, setPassedPasswordVerification] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isCheckingFormErrorPlacement, setIsCheckingFormErrorPlacement] = useState(false);
    const dispatch = useAppDispatch();

    useEffect(() => {
        setIsCheckingFormErrorPlacement(true);
    }, [])

    useEffect(() => {
        // Get form error element and change position
        let formErrorElements = document.getElementsByClassName('form-error');
        if (formErrorElements.length > 0) {
            // Loop
            for (let i = 0; i < formErrorElements.length; i++) {
                // Get form error element's width
                let formErrorElementWidth = formErrorElements[i].clientWidth;
                // Set form error element's left position
                let formErrorStyle = 'left: -' + (10 + formErrorElementWidth) + 'px;';
                // Set form error element's style
                formErrorElements[i].setAttribute('style', formErrorStyle);
            }
            // console.log("formErrorElements: ", formErrorElements);
            
        }

        setIsCheckingFormErrorPlacement(false);
    }, [isCheckingFormErrorPlacement])

    useEffect(() => {
        // Move onto OTP
        if (passedPasswordVerification) {
            navigate("/login/verify");
        }
    }, [passedPasswordVerification]);

    async function submitForm(values, setSubmitting) {
        // Submit results to db
        const apiLoginData: ReturnPropsAPIGetUserLoginResponse = await APIGetUserLoginResponse(values.email, values.pass, dispatch); 
        // console.log("apiLoginData: ", apiLoginData);
        if (apiLoginData.error === "") {

            // console.log("apiLoginData: ", apiLoginData);
            // return;
            
            // Set apiLoginData
            props.setApiLoginData(apiLoginData);

            // User passed password verification. Move onto OTP verification
            setPassedPasswordVerification(true);     
            setSubmitting(false);
        } else {
            setErrorMessage(apiLoginData.error);
            setSubmitting(false);
        }
    }

    function resetForm() {
        
    }

    function handleRegisterClick() {
        navigate("/register");
    }

    function handleResetPasswordClick() {
        navigate("/pre-password-reset");
    }

    return (
        <>
            {/* <img className="login-splash-screen" src={require('../../files/splashScreens/Splash-Screen-Farmland.png')} alt="Login Splash Screen" /> */}
            <motion.div
                className='form-container-login-register'
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5, ease: "easeInOut" }}
            >
                <Formik
                    initialValues={ { email: '', pass: '' } }
                    validate={ values => {
                        setIsCheckingFormErrorPlacement(true);
                        const errors = {
                            email: '',
                            pass: ''
                        };
                        
                        if (!values.email) {
                            errors.email = 'Required';
                        } else if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/i.test(values.email)) {
                            errors.email = 'Invalid email address';
                        }
                        if (!values.pass) {
                            errors.pass = 'Required'
                        }

                        if (values.email && /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/i.test(values.email) && values.pass) {
                            return {};
                        } else {
                            return errors;
                        }
                    }}
                    onSubmit={ (values, { setSubmitting }) => {
                        submitForm(values, setSubmitting);
                    }}
                    onReset={ (values) => {
                        resetForm();
                    }}
                    enableReinitialize={true}
                >
                    { ({ isSubmitting }) => (
                        <>
                            { isSubmitting ? (
                                <>
                                    <Loading withBackground={true} />
                                </>
                            ) : (
                                <Form>
                                    <h2>Login</h2>
                                    <div className='form-group-inputs'>
                                        <div className='field-group'>
                                            {/* <div className='form-field-title'>Email<div className='required-asterisk'>*</div></div> */}
                                            <Field type='email' name='email' placeholder='Email' as='input' autoFocus autoComplete='username' />
                                            <ErrorMessage name='email' component='div' className='form-error' />
                                        </div>
                                        <div className='field-group'>
                                            {/* <div className='form-field-title'>Password<div className='required-asterisk'>*</div></div> */}
                                            <Field as={CustomPasswordField} name='pass' placeholder='Password' autoComplete='new-password' />
                                            <ErrorMessage name='pass' component='div' className='form-error' />
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='button-group'>
                                        <button id="cancel-btn" type='reset'>Cancel</button>
                                        <button id="login-btn" type='submit' disabled={ isSubmitting }>Login</button>
                                        {/*<button id="register-btn" type="button" onClick={handleRegisterClick}>Register</button> */}
                                        <button id="reset-btn" type="button" onClick={handleResetPasswordClick}>Reset Password</button>
                                    </div>
                                    <div className={`error-message ${(errorMessage !== '' && errorMessage !== null) ? 'with-background' : ''}`}>
                                        {(errorMessage !== '' && errorMessage !== null) ? errorMessage : ''}
                                    </div>
                                </Form>
                            )}
                        </>
                    )}
                </Formik>
            </motion.div>
        </>
    );
}


export default LoginForm;